import gql from 'graphql-tag';

export const projectCommitteeCategoriesQuery = gql`
  query projectsCommitteeCategory {
    projectsCommitteeCategory
  }
`;
